export default __webpack_public_path__ + "static/media/logo-metamask.02e3ec27.png";